import classNames from 'classnames';
import { useEffect, useState } from 'react';

import * as St from './ImageWithSkeleton.styles';

interface ImageWithSkeletonProps {
  src?: string;
  className?: string;
  imgProps?: React.ImgHTMLAttributes<HTMLImageElement>;
}

const ImageWithSkeleton = ({
  src,
  className,
  imgProps,
}: ImageWithSkeletonProps): JSX.Element => {
  const [isImageLoading, setIsImageLoading] = useState(true);

  useEffect(() => {
    setIsImageLoading(true);
  }, [src]);

  return (
    <St.Container className={classNames(className)}>
      <St.Image
        {...imgProps}
        src={src}
        className={classNames(imgProps?.className, {
          'image--hidden': isImageLoading,
        })}
        onLoad={() => setIsImageLoading(false)}
      />
      {isImageLoading && <St.SkeletonImage active />}
    </St.Container>
  );
};

export default ImageWithSkeleton;
